import React from 'react';
import PropTypes from 'prop-types';
import { useCopyClipboard } from '../providers/useCopyClipboard';
const CopyClipboard = ({ value = '', children = () => null, ...propsWithNoDefaults }) => {
    const { dataHook, className, onCopy, resetTimeout } = propsWithNoDefaults;
    const { isCopied, copyToClipboard, reset } = useCopyClipboard({
        value,
        onCopy,
        resetTimeout,
    });
    return (React.createElement("div", { className: className, "data-hook": dataHook }, children({
        isCopied,
        copyToClipboard,
        reset,
    })));
};
CopyClipboard.displayName = 'CopyClipboard';
CopyClipboard.propTypes = {
    dataHook: PropTypes.string,
    children: PropTypes.func,
    onCopy: PropTypes.func,
    value: PropTypes.string,
    resetTimeout: PropTypes.number,
};
export default CopyClipboard;
//# sourceMappingURL=CopyClipboard.js.map